function displayedProductEvent (productId, skuId, isRoman, fabricSkuId, legType) {
  const eventName = 'displayedProduct'
  const productEvent = new CustomEvent(eventName, {
    detail: {
      'productId': productId,
      'skuId': skuId,
      'fabricSkuId' : fabricSkuId,
      'legType' : legType,
      'isRoman': isRoman}
  })
  if(document.readyState === "complete") {
    document.body.dispatchEvent(productEvent);
  } else {
    document.addEventListener("DOMContentLoaded", () => {
      document.body.dispatchEvent(productEvent);
    });
  }

  document.body.addEventListener('jl-events.browser.rviLoaded', (event) => {
    document.body.dispatchEvent(productEvent);
  })
}

export default displayedProductEvent;
